import React from 'react';
import ActivityFeed from '../components/ActivityFeed';
import { useAuth } from '../contexts/AuthContext';

const ActivityFeedPage: React.FC = () => {
  const { user } = useAuth();

  if (!user) return null;

  return <ActivityFeed currentUserId={user.id} />;
};

export default ActivityFeedPage;
